/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
let orders = [
  {
      "OrderId": "5f0739337f11877a8fd8570e",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3228560",
      "MarketId": "5f07391ef706a607479beadf",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.98,
      "Size": 100,
      "PotentialProfit": 98,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f07394bf522024f93fe2e3b",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3228560",
      "MarketId": "5f07391ef706a607479beadf",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.98,
      "Size": 100,
      "PotentialProfit": 98,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f0739a1f706a607479beca0",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3228560",
      "MarketId": "5f07391ef706a607479beadf",
      "SelectionId": "76776",
      "Side": "LAY",
      "Price": 1.85,
      "Size": 100,
      "PotentialProfit": 100,
      "PotentialLoss": 85,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f07f6937f11877a8fda45eb",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3242208",
      "MarketId": "5f07f61e7f11877a8fda44b7",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.46,
      "Size": 100,
      "PotentialProfit": 46,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f07f723f522024f9300040d",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3242208",
      "MarketId": "5f07f61e7f11877a8fda44b7",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.29,
      "Size": 200,
      "PotentialProfit": 58,
      "PotentialLoss": 200,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f07f72f3b603752cff12701",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3242208",
      "MarketId": "5f07f61e7f11877a8fda44b7",
      "SelectionId": "76776",
      "Side": "LAY",
      "Price": 1.32,
      "Size": 500,
      "PotentialProfit": 500,
      "PotentialLoss": 160,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f07f7fcf706a607479ddded",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3242290",
      "MarketId": "5f07f7543b603752cff12775",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.86,
      "Size": 100,
      "PotentialProfit": 86,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f07f8483b603752cff129ae",
      "UserId": "casino_user_2",
      "CompetitionId": "56767",
      "EventId": "3242290",
      "MarketId": "5f07f7543b603752cff12775",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 2.09,
      "Size": 100,
      "PotentialProfit": 108,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f07f85a7f11877a8fda4af2",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3242290",
      "MarketId": "5f07f7543b603752cff12775",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.86,
      "Size": 200,
      "PotentialProfit": 172,
      "PotentialLoss": 200,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f07f864f522024f93000735",
      "UserId": "casino_user_2",
      "CompetitionId": "56767",
      "EventId": "3242290",
      "MarketId": "5f07f7543b603752cff12775",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.86,
      "Size": 200,
      "PotentialProfit": 172,
      "PotentialLoss": 200,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f07fb5c7f11877a8fda5389",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3242520",
      "MarketId": "5f07faa6f522024f93000ca7",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.78,
      "Size": 100,
      "PotentialProfit": 78,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f07fb79f522024f93000ee7",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3242520",
      "MarketId": "5f07faa6f522024f93000ca7",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.47,
      "Size": 200,
      "PotentialProfit": 94,
      "PotentialLoss": 200,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f07fb8d3b603752cff13231",
      "UserId": "casino_user_2",
      "CompetitionId": "56767",
      "EventId": "3242520",
      "MarketId": "5f07faa6f522024f93000ca7",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.47,
      "Size": 100,
      "PotentialProfit": 47,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f080e547f11877a8fda8e63",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3243869",
      "MarketId": "5f080dd17f11877a8fda8cd2",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.59,
      "Size": 100,
      "PotentialProfit": 59.00000000000001,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f080e85f706a607479e233a",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3243869",
      "MarketId": "5f080dd17f11877a8fda8cd2",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 2.88,
      "Size": 200,
      "PotentialProfit": 376,
      "PotentialLoss": 200,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f08102c7f11877a8fda94e5",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3244017",
      "MarketId": "5f081016f522024f93004a7f",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.98,
      "Size": 100,
      "PotentialProfit": 98,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "PLACED"
  },
  {
      "OrderId": "5f0810413b603752cff16ce3",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244017",
      "MarketId": "5f081016f522024f93004a7f",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.98,
      "Size": 200,
      "PotentialProfit": 196,
      "PotentialLoss": 200,
      "OrderBonus": 0,
      "BetStatus": "PLACED"
  },
  {
      "OrderId": "5f08106b3b603752cff16d54",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244017",
      "MarketId": "5f081016f522024f93004a7f",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.7,
      "Size": 100,
      "PotentialProfit": 70,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "PLACED"
  },
  {
      "OrderId": "5f081073f522024f93004b7a",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244017",
      "MarketId": "5f081016f522024f93004a7f",
      "SelectionId": "76777",
      "Side": "LAY",
      "Price": 1.74,
      "Size": 100,
      "PotentialProfit": 100,
      "PotentialLoss": 74,
      "OrderBonus": 0,
      "BetStatus": "PLACED"
  },
  {
      "OrderId": "5f08107ff706a607479e295b",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244017",
      "MarketId": "5f081016f522024f93004a7f",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 2.34,
      "Size": 200,
      "PotentialProfit": 268,
      "PotentialLoss": 200,
      "OrderBonus": 0,
      "BetStatus": "PLACED"
  },
  {
      "OrderId": "5f0811b3f522024f93004f39",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3244111",
      "MarketId": "5f08117ef706a607479e2ca3",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.98,
      "Size": 100,
      "PotentialProfit": 98,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f0811da7f11877a8fda99aa",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244111",
      "MarketId": "5f08117ef706a607479e2ca3",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 3.6,
      "Size": 100,
      "PotentialProfit": 260,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f08121cf706a607479e2e78",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244111",
      "MarketId": "5f08117ef706a607479e2ca3",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.3,
      "Size": 1000,
      "PotentialProfit": 300.00000000000006,
      "PotentialLoss": 1000,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f08123a3b603752cff17223",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244111",
      "MarketId": "5f08117ef706a607479e2ca3",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.3,
      "Size": 500,
      "PotentialProfit": 150.00000000000003,
      "PotentialLoss": 500,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f0812f47f11877a8fda9ca7",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3244207",
      "MarketId": "5f0812f0f706a607479e30cb",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.98,
      "Size": 100,
      "PotentialProfit": 98,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f0812f93b603752cff1741b",
      "UserId": "casino_user_1",
      "CompetitionId": "56767",
      "EventId": "3244207",
      "MarketId": "5f0812f0f706a607479e30cb",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.98,
      "Size": 100,
      "PotentialProfit": 98,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f08130c3b603752cff17441",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244207",
      "MarketId": "5f0812f0f706a607479e30cb",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.98,
      "Size": 200,
      "PotentialProfit": 196,
      "PotentialLoss": 200,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f081311f522024f930052c5",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244207",
      "MarketId": "5f0812f0f706a607479e30cb",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.98,
      "Size": 500,
      "PotentialProfit": 490,
      "PotentialLoss": 500,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f081372f706a607479e3235",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244207",
      "MarketId": "5f0812f0f706a607479e30cb",
      "SelectionId": "76776",
      "Side": "BACK",
      "Price": 1.92,
      "Size": 100,
      "PotentialProfit": 92,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "LOST"
  },
  {
      "OrderId": "5f0813933b603752cff175b8",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244207",
      "MarketId": "5f0812f0f706a607479e30cb",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.5,
      "Size": 100,
      "PotentialProfit": 50,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f0813a7f706a607479e32cf",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244207",
      "MarketId": "5f0812f0f706a607479e30cb",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.5,
      "Size": 1000,
      "PotentialProfit": 500,
      "PotentialLoss": 1000,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f0813b0f706a607479e32ea",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244207",
      "MarketId": "5f0812f0f706a607479e30cb",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.5,
      "Size": 200,
      "PotentialProfit": 100,
      "PotentialLoss": 200,
      "OrderBonus": 0,
      "BetStatus": "WON"
  },
  {
      "OrderId": "5f0813b87f11877a8fda9ed6",
      "UserId": "casino_user_3",
      "CompetitionId": "56767",
      "EventId": "3244207",
      "MarketId": "5f0812f0f706a607479e30cb",
      "SelectionId": "76777",
      "Side": "BACK",
      "Price": 1.13,
      "Size": 100,
      "PotentialProfit": 12.99999999999999,
      "PotentialLoss": 100,
      "OrderBonus": 0,
      "BetStatus": "WON"
  }
]

class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      passcode: "",
      pageLimit: 10,
      pageActive: 1,
      order_list:orders
    };
  }  
  render() {
    let pages = []
      for (let i = 0; i < (Math.floor(this.state.order_list.length / this.state.pageLimit) + 1); i++) {
         pages.push(<li class={this.state.pageActive === i + 1 ? "paginate_button page-item active" : "paginate_button page-item"} onClick={() => { this.setState({ pageActive: i + 1 }) }}><a aria-controls="example" data-dt-idx="1" tabindex="0" class="page-link">{i + 1}</a></li>)
      }
    return (
      <body class="bethubs">
        <Header history = {this.props.history} />
        <div class="wrapper">
          <div class="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
            <button onclick="w3_close()" class="w3-bar-item w3-large bg-hover">Close &times;</button>
            <ul>
              <li><a href="list-of-clients.html">List of Clients</a></li>
              <li><a href="#">Market Analysis</a></li>
              <li><a href="import-event.html">Import Event</a></li>
              <li>
                <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" class="dropdown-toggle"> Live Markets </a>
                <ul class="list-unstyled collapse" id="homeSubmenu" >
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
              <li>
                <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" class="dropdown-toggle"> Reports</a>
                <ul class="list-unstyled collapse" id="home1Submenu" >
                  <li><a href="#">Test 1</a></li>
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="container-fluid container-padding-0">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <div class="main-box">
                  <div>
                    <h5 class="text-blue  mb-4">
                    <span class="text-red ">This is only Layout Design of Page.</span>
                    <br /><br />
                    <span>Order History</span>
                    </h5>
                  </div>
                  <div class="row mt-1">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 table-responsive">
                      {this.state.order_list.length > 0 ? <table id="example" class="table table-striped table-bordered font-12 table-sm" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>User</th>
                            <th>Order ID</th>
                            <th>Compatition</th>
                            <th>Event</th>
                            <th>Team</th>
                            <th>Back/Lay</th>
                            <th>Prize</th>
                            <th>Size</th>
                            <th>Potential Profit</th>
                            <th>Potential Loss</th>
                            <th>Order Bonus</th>
                            <th>Bet Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.order_list.map((ord, i) => {
                            return (<>{i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) && <tr>
                              <td><span>{i+1}</span></td>
                              <td><span>{ord.UserId}</span></td>
                              <td><span>{ord.OrderId}</span></td>
                              <td><span>{ord.CompetitionId}</span></td>
                              <td><span>{ord.EventId}</span></td>
                              <td><span>{ord.SelectionId}</span></td>
                              <td><span>{ord.Side}</span></td>
                              <td><span>{ord.Price}</span></td>
                              <td><span>{ord.Size}</span></td>
                              <td><span>{ord.PotentialProfit}</span></td>
                              <td><span>{ord.PotentialLoss}</span></td>
                              <td><span>{ord.OrderBonus}</span></td>
                              <td><span>{ord.BetStatus}</span></td>     
                            </tr>}</>
                            )
                          })}
                        </tbody>
                      </table> :
                        <span>No order found under your account.</span>
                      }
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info" id="example_info" role="status" aria-live="polite">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) < this.state.order_list.length ? (this.state.pageLimit * this.state.pageActive) : this.state.order_list.length} of {this.state.order_list.length} entries</div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <div class="dataTables_paginate paging_simple_numbers" id="example_paginate">
                        <ul class="pagination">
                          <li class={this.state.pageActive === 1 ? "paginate_button page-item previous " : "paginate_button page-item previous disabled"} onClick={() => { if (this.state.pageActive > 1) { this.setState({ pageActive: (this.state.pageActive - 1) }) } }} id="example_previous"><a aria-controls="example" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>
                          {
                            pages
                          }
                          <li class={this.state.pageActive === Math.floor(this.state.order_list.length / this.state.pageLimit) ? "paginate_button page-item next disabled" : "paginate_button page-item next "} onClick={() => { if (this.state.pageActive === Math.floor(this.state.order_list.length / this.state.pageLimit)) { this.setState({ pageActive: (this.state.pageActive + 1) }) } }} id="example_next"><a aria-controls="example" data-dt-idx="2" tabindex="0" class="page-link">Next</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </body>

    )
  }
}
function mapStateToProps(state) {
  return {
  };
}
function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Auth);